// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { structureUrl } from "../../const";
import { getFormData } from "../utils";

export const topicsApi = createApi({
  reducerPath: "topicsApi",
  baseQuery: fetchBaseQuery({ baseUrl: structureUrl }),
  endpoints: (builder) => ({
    getStructNodes: builder.query({
      query: ({ licenseKey }) => {
        return {
          url: "/nodes",
          method: "post",
          formData: true,
          body: getFormData([["SERVER_KEY", licenseKey]]),
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetStructNodesQuery, useLazyGetStructNodesQuery } = topicsApi;
